<template>
  <div
    ref="dragBall"
    class="drag-ball"
    :style="{ left: localPostion.left, top: localPostion.top }"
    @touchend.stop="touchend"
    @touchmove.stop="touchmove"
    @touchstart.stop="touchstart"
  >
    <div class="drag-content">
      <slot name="default">{{ value }}</slot>
    </div>
  </div>
</template>
<script>
  import storage from '@/utils/storage'
  export default {
    name: 'DragBall',
    props: {
      value: {
        type: String,
        default: '悬浮球！',
      },
    },
    data() {
      return {
        canDrag: false,
        tap: false,
        // 偏移
        inset: {
          left: 10,
          top: 0,
        },
        // 移动
        move: {},
        // 位置
        position: {
          left: 0,
          top: 0,
        },
        // 初始位置
        positionOld: {},
        startTime: null,
        endTime: null,

        //
        localPostion: {
          left: null,
          top: null,
        },
      }
    },
    computed: {
      dragBall() {
        return this.$refs.dragBall
      },
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        // 获取缓存位置
        let localPostion = storage.get('dragBallPosition')
        if (localPostion) {
          localPostion = JSON.parse(localPostion)
          this.localPostion = localPostion
        }

        // 不要删除  解决fixed 在滚动后 touchstart失效的问题
        var navbar = document.querySelector('.drag-ball')
        window.addEventListener('touchstart', (e) => {
          if (e.target === navbar) {
            // callback
          }
        })
      },
      touchstart(e) {
        if (!this.canDrag) {
          this.startTime = e.timeStamp
          this.positionOld = this.getPosition(this.dragBall)
          this.position = { ...this.positionOld }
          this.inset = {
            left: e.targetTouches[0].clientX - this.positionOld.left,
            top: e.targetTouches[0].clientY - this.positionOld.top,
          }
          this.canDrag = true
        }
      },
      touchmove(e) {
        if (this.canDrag) {
          let left = e.targetTouches[0].clientX - this.inset.left
          let top = e.targetTouches[0].clientY - this.inset.top
          if (left < 0) {
            left = 0
          } else if (left > window.innerWidth - this.dragBall.offsetWidth) {
            left = window.innerWidth - this.dragBall.offsetWidth
          }
          if (top < 0) {
            top = 0
          } else if (top > window.innerHeight - this.dragBall.offsetHeight) {
            top = window.innerHeight - this.dragBall.offsetHeight
          }
          this.dragBall.style.left = left + 'px'
          this.dragBall.style.top = top + 'px'
          this.move = {
            x: left - this.positionOld.left,
            y: top - this.positionOld.top,
          }
          this.position = { left, top }
        }
      },
      touchend(e) {
        this.tap = false
        if (this.canDrag) {
          this.endTime = e.timeStamp
          if (
            this.endTime - this.startTime > 400 ||
            Math.abs(this.move.x) > 2 ||
            Math.abs(this.move.y) > 2
          ) {
            // 非单击事件
            if (
              this.position.left + this.dragBall.offsetWidth / 2 >
              window.innerWidth / 2
            ) {
              this.dragBall.style.left =
                window.innerWidth - this.dragBall.offsetWidth - 10 + 'px'
            } else {
              this.dragBall.style.left = 10 + 'px'
            }
          } else {
            this.$emit('click')
          }
          console.log(this.dragBall.style.left)
          this.savePosition()
          this.inset = {}
          this.move = {}
          this.position = {}
          this.canDrag = false
        }
      },
      savePosition() {
        const position = {
          left: this.dragBall.style.left,
          top: this.dragBall.style.top,
        }
        storage.set('dragBallPosition', JSON.stringify(position))
      },
      // 获取dom的绝对位置
      getPosition(source) {
        let left = source.offsetLeft //获取元素相对于其父元素的left值var left
        let top = source.offsetTop
        let current = source.offsetParent // 取得元素的offsetParent // 一直循环直到根元素
        while (current != null) {
          left += current.offsetLeft
          top += current.offsetTop
          current = current.offsetParent
        }
        return {
          left: left,
          top: top,
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .drag-ball {
    position: fixed;
    z-index: 10003;
    right: 10px;
    top: 80%;
    width: 40px;
    height: 40px;
    background: #b57e48;
    border-radius: 50%;
    overflow: hidden;
    padding: 10px;
    user-select: none;
    touch-action: none;
    box-shadow: 0 0 4px rgba($color: #000, $alpha: 0.5);
  }
  .drag-ball .drag-content {
    overflow-wrap: break-word;
    font-size: 14px;
    color: #fff;
    letter-spacing: 2px;
  }
</style>
